
<div mat-dialog-title>Replace a Security<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>
  <div class="block"><strong>{{replaceSecurityModels.length}} security models selected</strong></div>

  <div class="block" id="selectedDeleteBlendedModels"
    style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #767676; padding: 5px; background-color: #FFFFFF;">
    <table id="blendedDeleteModels" style="width:100%; table-layout: fixed;">
      @for (models of replaceSecurityModels; track models) {
        <tr>
          <td style="width: 50%; vertical-align: top;">
            <div tooltip [tooltipTitle]="models.name" [tooltipRequiresTruncation]="true" tooltipPosition="right">{{models.name}}</div>
          </td>
          <td style="width: 50%; vertical-align: top;">
            <div tooltip [tooltipTitle]="models.description" [tooltipRequiresTruncation]="true" tooltipPosition="right">{{models.description}}</div>
          </td>
        </tr>
      }
    </table>
  </div>
  <div>
    <table>
      <tr>
        <th align="left" style="vertical-align: top; margin-bottom: 10px;"><label>Replace this security</label></th>
        <td>
          <div style="margin-bottom: 10px;">
            <irb-dropdown-filter  #IrbDropdownReplaceWithSecurity (search)="getSelectedList($event)"
              id="irbSelectedRebalanceTypeDropdown"
              [(value)]="selectedModelSecurityval"
              (selection)="getSelectedSecurityModelDropdownValue($event)"
              style="width: 250px !important;" size="25"
              (valueChange) ="onInputChange()"
            ></irb-dropdown-filter>
          </div>
        </td>
      </tr>
      <tr>
        <th align="left" style="vertical-align: top;"><label>With this security</label></th>
        <td>
          <div>
            <irb-dropdown-search #securitiesDropdown [(value)]="securitiesList"
              id="irbSecurityDropdown"
              (search)="getsecurityDropdown($event)"
              (selection)="onSecuritiesChange($event)"
              style="width: 250px !important;vertical-align: middle;" size="25"
              (clearSelection)="clearReplaceSecurity()"
              (valueChange) ="onInputChange()"
            ></irb-dropdown-search>
          </div>
        </td>
      </tr>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  <button id="closeButton" (click)="replaceSecurity()" class="btn-medium-primary" [disabled]="canNotReplaceSecurity">Replace security</button>
</mat-dialog-actions>

